import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../context/PermissionContext";

/**
 * Wraps a route element and blocks rendering if the user lacks the required
 * permission on the given menu key.
 *
 * Usage in routes:
 *   <Route
 *     path="check-list-builder/check-list"
 *     element={
 *       <ProtectedRoute menuKey="CHECKLIST" action="read">
 *         <ChecklistExecution />
 *       </ProtectedRoute>
 *     }
 *   />
 *
 * @param {string}      menuKey   The menu key to check
 * @param {string}      [action]  Default "read"
 * @param {ReactNode}   children  The protected page component
 */
const ProtectedRoute = ({ menuKey, action = "read", children }) => {
  const { can, loading } = usePermissions();
  const navigate = useNavigate();

  if (loading) return null; // or a spinner – avoids flash

  if (!can(menuKey, action)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You don't have permission to access this page."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Back to Dashboard
          </Button>
        }
      />
    );
  }

  return children;
};

export default ProtectedRoute;